import { DownloadSharedURLDO, DownloadSharedURLResponseDO } from "../../commonDomainObjects";
import { HTTP_VERBS } from "../../enums";

export const httpVerb = HTTP_VERBS.GET;
export const url = "/api/users/access/:id/:s3UniqueName";
export class Params extends DownloadSharedURLDO {}
export class Response extends DownloadSharedURLResponseDO {}
